


























<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    white--text
  >
    <v-container fluid>
      <v-layout
        row
        justify-center
      >
        <div @click="standardCutSelection()">
          <v-checkbox
            v-model="standardCut"
            label="Standard Cut Selection (Includes all cuts in the most asked for ways) (Standard)"
          ></v-checkbox>
        </div>
      </v-layout>
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          sm6
          lg3
        >
          <v-select
            v-model="thickness"
            :items="form.lists.thicknessList"
            :rules="[v => !!v || 'Thickness is required']"
            label="*Steak Thickness"
            required
          ></v-select>
        </v-flex>
        <v-flex
          xs12
          sm6
          lg3
        >
          <v-select
            v-model="wrapFor"
            :items="form.lists.wrapForList"
            :rules="[v => !!v || 'Steaks per Package is required']"
            label="*Steaks per Package"
            required
          ></v-select>
        </v-flex>
        <v-flex
          xs12
          sm6
          lg3
        >
          <v-select
            v-model="roastSize"
            :items="form.lists.roastSizeList"
            :rules="[v => !!v || 'Roast Size is required']"
            label="*Roast Size"
            required
          ></v-select>
        </v-flex>
        <v-flex
          xs12
          sm6
          lg3
        >
          <v-select
            v-model="groundBeefSize"
            :items="form.lists.groundBeefSizeList"
            :rules="[v => !!v || 'Ground Beef lbs/Package is required']"
            label="*Ground Beef lbs/Package"
            required
          >
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapMutations } from 'vuex'

export default {
 name: 'beefInfo',
 props: {
  clearClear: '',
 },
 methods: {
  ...mapMutations('data', [
   'changeTypesOfMeatToStandard',
   'changeTypesOfMeatToState',
  ]),
  standardCutSelection() {
   if (!this.standardCut) {
    return this.clearChild()
   } else {
    this.thickness = '1 inch (Standard)'
    this.wrapFor = '2 Steaks/Package (Standard)'
    this.roastSize = '2-4 lbs/Roast (Standard)'
    this.groundBeefSize = '1.5 lbs/Package (Standard)'
    return this.changeTypesOfMeatToStandard()
   }
  },
  clearChild() {
   this.thickness = ''
   this.wrapFor = ''
   this.roastSize = ''
   this.groundBeefSize = ''
   return this.changeTypesOfMeatToState()
  },
 },
 computed: {
  ...mapFields('data', [
   'form',
   'form.valid',
   'form.standardCut',
   'form.thickness',
   'form.wrapFor',
   'form.roastSize',
   'form.groundBeefSize',
  ]),
 },
}
</script>

<style>
</style>
